export const TetronLogo = () => {
  return (
    <svg
      width="25"
      height="12"
      viewBox="0 0 25 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.65945 0.90255L10.9764 0.892578L6.70819 5.99811H0.000976562L3.65945 0.90255ZM24.9995 0.892578L21.341 5.99811H15.2044C14.7108 5.99811 14.4241 5.43987 14.7115 5.03869L17.6825 0.892578H24.9995ZM10.3662 11.1083L14.0248 6.00026L10.976 0.896773L6.70775 6.00159L10.3662 11.1083Z"
        fill="#009FDA"
      />
    </svg>
  )
}
